<template>
    <ul v-if="pager.pages && pager.pages.length" class="pagination new-pager" :style="ulStyles">

        <li class="total-content">Total : {{totalJoinedRunner}}</li>
        <li v-for="(page,index) in pager.pages" :key="index+1" class="page-item page-number" :class="{'active': pager.currentPage === index+1  && !isFilterOn}" :style="liStyles">
            <a class="page-link" @click="setPage(index+1,true)" :style="aStyles">{{page}}</a>
        </li>
    </ul>
</template>

<script>
    import paginate from 'jw-paginate'
    const defaultLabels = {
        first: 'First',
        last: 'Last',
        previous: 'Previous',
        next: 'Next'
    }
    const defaultStyles = {
        ul: {
            margin: 0,
            padding: 0,
            display: 'inline-block'
        },
        li: {
            listStyle: 'none',
            display: 'inline',
            textAlign: 'center'
        },
        a: {
            cursor: 'pointer',
            padding: '6px 12px',
            display: 'block',
            float: 'left'
        }
    }
    export default {
     name: 'runnerPagination',
        props: {
            items: {
                type: Array,
                // required: true
            },
            total:{
                type: Number,
                default: 0
            },
            totalJoinedRunner:{
                type: Number,
                default: 0
            },
            currentPageIndex:{
                default: 1
            },
            initialPage: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 50
            },
            maxPages: {
                type: Number,
                default: 50
            },
            labels: {
                type: Object,
                default: () => defaultLabels
            },
            styles: {
                type: Object
            },
            disableDefaultStyles: {
                type: Boolean,
                default: false
            },
            isFilterOn: {
                type: Boolean,
                default: false
            },

        },
        data () {
            return {
                pager: {},
                ulStyles: {},
                liStyles: {},
                aStyles: {}
            }
        },
        created () {
            if (!this.$listeners.changePage) {
                throw 'Missing required event listener: "changePage"'
            }
            // set default styles unless disabled
            if (!this.disableDefaultStyles) {
                this.ulStyles = defaultStyles.ul
                this.liStyles = defaultStyles.li
                this.aStyles = defaultStyles.a
            }
            // merge custom styles with default styles
            if (this.styles) {
                this.ulStyles = { ...this.ulStyles, ...this.styles.ul }
                this.liStyles = { ...this.liStyles, ...this.styles.li }
                this.aStyles = { ...this.aStyles, ...this.styles.a }
            }
            // set to initial page
            this.setPage(this.initialPage)
        },
        methods: {
            setPage(page,onClickPager) {
                //console.log("onClickPager>>>",onClickPager)
                //console.log("page>>---",page)
                const { pageSize, maxPages,total } = this
                // get new pager object for specified page
                //const pager = paginate(items.length, page, pageSize, maxPages)
                const pager = paginate(total, page, pageSize, maxPages)
                var pageNo=[]
                var i=1
                pager.pages.forEach(function (p) {
                    pageNo.push(i)
                    i=i+50  
                })

                pager.pages = pageNo

                // get new page of items from items array
                //const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1)
                // update pager
                this.pager = pager
                // emit change page event to parent component
                this.$emit('changePage', pager,onClickPager)
                //this.$emit('changePage', pager)
            }
        },
        watch: {
            items () {
                this.setPage(this.initialPage)
            },
            total () {
                this.setPage(this.currentPageIndex)
            },
            isFilterOn (){
                this.setPage(this.currentPageIndex)
            }
            
        }
    }
</script>
<style>
ul.pagination.new-pager {
    text-align: left;
}
.new-pager li.total-content {
    border: none;
    margin-right: 20px;
    color: black;
    font-size: 15px;
}
.new-pager .active {
    background-color: #454598;
}
.new-pager .active a {
    color: #ffffff;
}
.pagination.new-pager li{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// RunnerPagination.vue?cc0c8d30